// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".content[data-v-8c21216c]{padding:20px;flex-direction:column;text-align:center;background-color:#fff}", "",{"version":3,"sources":["/builds/hydra/intern/feedback-tool-www/src/components/no-deliverables.vue"],"names":[],"mappings":"AACA,0BACE,YAAA,CACA,qBAAA,CACA,iBAAA,CACA,qBAAA","file":"no-deliverables.vue","sourcesContent":["\n.content {\n  padding: 20px;\n  flex-direction: column;\n  text-align: center;\n  background-color: #fff;\n}\n"]}]);
// Exports
module.exports = exports;
